// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__SdpIU","bannerContent":"styles_bannerContent__l_x0G","title":"styles_title__QPM7x","description":"styles_description__bfFYe"};